import {
  Divider,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import enLocale from 'date-fns/locale/en-IN'
import { getUserType } from '../../components/tsComponents/AuthGuard'

export const OutletAndDatePickerUI = (props) => {
  const {
    outlets,
    onOutletChange,
    selectedOutlet,
    fromDate,
    toDate,
    onFromDateChange,
    onFromDateError,
    onToDateChange,
    onToDateError,
    showFromDateError,
    showToDateError,
    fromDateErrorMessage,
    toDateErrorMessage,
    exportComponent,
    onlyDateSelection = false
  } = props

  const userType = getUserType()
  // Use provided outlets as-is; do not inject 'All Outlets' here to avoid duplicates
  const outletOptions = Array.isArray(outlets) ? outlets : []

  return (
    <Grid container spacing={6} style={{ marginTop: 5 }}>
      {!onlyDateSelection && (
        <Grid item md={3}>
          <TextField
            label="Outlet"
            id="outlet_id"
            name="outlet_id"
            variant="outlined"
            margin="dense"
            value={selectedOutlet}
            onChange={onOutletChange}
            select
            fullWidth
            size={userType === 'Owner' ? 'small' : 'medium'}
          >
            {outletOptions?.map((outlet) => (
              <MenuItem key={outlet?._id} value={outlet?._id}>
                <Grid container direction={'column'}>
                  <Grid item>
                    <Typography variant="body1">{outlet?.name}</Typography>
                  </Grid>
                  {userType === 'Owner' && (
                    <>
                      <Grid item>
                        <Typography variant="caption">
                          {outlet?.sub_business_name}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Divider />
                      </Grid>
                    </>
                  )}
                </Grid>
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      <Grid item>
        <LocalizationProvider
          adapterLocale={enLocale}
          dateAdapter={AdapterDateFns}
        >
          <Stack direction={'row'} spacing={5} sx={{ pt: 2 }}>
            {fromDate && (
              <DatePicker
                disableFuture
                label="From Date"
                minDate={new Date('2022-01-01')}
                value={fromDate}
                onChange={onFromDateChange}
                onError={onFromDateError}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    error={showFromDateError}
                    helperText={showFromDateError ? fromDateErrorMessage : ''}
                  />
                )}
              />
            )}
            {toDate && (
              <DatePicker
                disableFuture
                label="To Date"
                format="DD-MM-YYYY"
                minDate={new Date('2022-01-01')}
                value={toDate}
                onChange={onToDateChange}
                onError={onToDateError}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    error={showToDateError}
                    helperText={showToDateError ? toDateErrorMessage : ''}
                  />
                )}
              />
            )}
          </Stack>
        </LocalizationProvider>
      </Grid>
      {exportComponent && <Grid item>{exportComponent}</Grid>}
    </Grid>
  )
}
